module.exports = __webpack_public_path__ + "clickup-logo-62c2307f9a248f04fefdaf0dca85f3da.webp";